import { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as districtService from '../../services/districtAPI';
import { fetchDistrictListFailure, fetchDistrictListSuccess } from './actions';
import { FETCH_DISTRICT_LIST_REQUEST } from './actionTypes';
import { IFetchDistrictListRequest, IDistrictListItem } from './types';

export function* fetchDistrictListSagaRequest({
  divisionId,
  successCb,
  failureCb
}: IFetchDistrictListRequest): SagaIterator {
  try {
    const { data } = yield call(districtService.fetchDistrictList as any, divisionId);
    const entity = (data?.entity || []) as IDistrictListItem[];
    const total = typeof data?.totalCount === 'number' ? data.totalCount : entity.length;
    const payload = { districtList: entity, total };
    successCb?.(payload);
    yield put(fetchDistrictListSuccess(payload));
  } catch (e) {
    if (e instanceof Error) {
      failureCb?.(e);
      yield put(fetchDistrictListFailure(e));
    }
  }
}

function* districtSaga() {
  yield all([takeLatest(FETCH_DISTRICT_LIST_REQUEST, fetchDistrictListSagaRequest)]);
}

export default districtSaga;
